import { Injectable } from '@angular/core';


export const bearerToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjoiYWRtaW4iLCJpYXQiOjE2NzU3NTI1Mjh9.8nOD8rck6aaNNETau8JeActb8rBupTZclWJqrUKwO4M";
/** Mock client-side authentication/authorization service */
@Injectable()
export class AuthService {
	/* hard coded the bearer token for the json server */
	private authToken = bearerToken;
	getAuthorizationToken() {
		return this.authToken;
	}
}
